import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CTA from './components/CTA';
import { getTotalEstimatedReturnText } from '../../../../../common/utils/estimatedReturn';
import { calculateMoneyBreakdown } from '../../../../../common/utils/calculateStake'
import ErrorBanner from '../../../../../common/errorBanner'
import Deposit from '../../../../../common/deposit'
import { ERROR_CODES } from '../../../../../common/utils/apiErrors'
import FreeBetsContainer from '../../../FreeBetsContainer'

export class ActionBar extends Component {

    renderFreeBets() {
        const {
            isUserLoggedIn,
            selectedBets,
            numberOfFreeBets,
            currencySign,
            freeBetsEnabled,
        } = this.props

        return (
            !isUserLoggedIn ||
            selectedBets.length !== 1 ||
            numberOfFreeBets === 0 ||
            !freeBetsEnabled
        )
            ? null
            : (
                <FreeBetsContainer
                    currencySign={currencySign}
                />
            )
    }

    renderLeftSide() {
        const {
            isQuickslipMode,
            onAddToBetslip,
            isUserLoggedIn,
            feed,
            selectedBets,
        } = this.props;

        if (
            isQuickslipMode &&
            selectedBets[0] &&
            selectedBets[0].error.errorId === ERROR_CODES.BETTING_SUSPENDED
        ) {
            return null;
        }

        if (!isQuickslipMode) {
            return (
                <Deposit
                    isUserLoggedIn={isUserLoggedIn}
                    feed={feed}
                    className="bs-actionBar__small"
                />
            )
        }

        return (
            <button
                className={
                    `bs-btn
                    bs-btn_default
                    bs-actionBar__button
                    bs-actionBar__half`
                }
                type="submit"
                onClick={onAddToBetslip}
            >
                <span>Add to Bet Slip</span>
            </button>
        )
    }

    renderMoneyBreakdown() {
        const {
            selectedBets,
            freeBetAmount,
            currencySign,
        } = this.props

        const bet = selectedBets[0]
        const stake = parseFloat(bet.stake, 10)

        // Do not render the breakdown if no stake is input
        if (isNaN(stake)) {
            return null
        }

        const {
            userStake,
            freeStake,
        } = calculateMoneyBreakdown(stake, bet, freeBetAmount)

        const userStakeText = `${currencySign}${userStake.toFixed(2)}`
        const freeStakeText = `${currencySign}${freeStake.toFixed(2)}`

        return (
            <div className="bs-betForm__moneyBreakdown">
                <div className="bs-betForm__moneyBreakdownLine">
                    <span className="bs-betForm__moneyBreakdownLabel">Your Money</span>
                    <span className="bs-betForm__moneyBreakdownValue">{userStakeText}</span>
                </div>
                <div className="bs-betForm__moneyBreakdownLine">
                    <span className="bs-betForm__moneyBreakdownLabel">Free Bet Used</span>
                    <span className="bs-betForm__moneyBreakdownValue">{freeStakeText}</span>
                </div>
            </div>
        )
    }

    render() {
        const {
            totalStake,
            currencySign,
            className,
            selectedBets,
            multiples,
            genericError,
            isQuickslipMode,
            freeBetIsSelected,
            freeBetAmount,
        } = this.props
        const parsedStake = parseFloat(totalStake)
        const stakeText = `${currencySign}${parsedStake.toFixed(2)}`
        const errorBanner = (!isQuickslipMode && genericError.errorId !== null)
            ? <ErrorBanner message={genericError.message} />
            : null
        const freeBets = isQuickslipMode ? this.renderFreeBets() : null
        const moneyBreakdown = freeBetIsSelected ? this.renderMoneyBreakdown() : null

        return (
            <div
                className={classNames('bs-drawer__actionBar', className)}
            >
                { errorBanner }
                { freeBets }
                { moneyBreakdown }
                <div className="bs-betForm__totalStake">
                    <div className="bs-betForm__totalStakeLine bs-betForm__totalStakeLine_stake">
                        <span className="bs-betForm__totalStakeLabel">Total Stake</span>
                        <span className="bs-betForm__totalStakeValue">
                            { stakeText }
                        </span>
                    </div>
                    <div className="bs-betForm__totalStakeLine bs-betForm__totalStakeLine_returns">
                        <span className="bs-betForm__totalStakeLabel">Estimated Returns</span>
                        <span className="bs-betForm__estimatedReturnsValue">
                            {
                                getTotalEstimatedReturnText(
                                    selectedBets,
                                    multiples,
                                    currencySign,
                                    freeBetIsSelected,
                                    freeBetAmount,
                                )
                            }
                        </span>
                    </div>
                </div>
                <div className="bs-actionBar bs-betForm__actionBar bs-section">
                    { this.renderLeftSide() }
                    <CTA />
                </div>
            </div>
        );
    }
}

ActionBar.defaultProps = {
    selectedBets: [],
    multiples: [],
    className: '',
    totalStake: '0.00',
    genericError: {
        message: null,
        errorId: null,
    },
    freeBetAmount: null,
}

ActionBar.propTypes = {
    feed: PropTypes.string.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
    selectedBets: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    multiples: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    currencySign: PropTypes.string.isRequired,
    className: PropTypes.string,
    totalStake: PropTypes.string.isRequired,
    onAddToBetslip: PropTypes.func.isRequired,
    isQuickslipMode: PropTypes.bool.isRequired,
    genericError: PropTypes.shape({
        message: PropTypes.string,
        errorId: PropTypes.string,
    }),
    numberOfFreeBets: PropTypes.number.isRequired,
    freeBetsEnabled: PropTypes.bool.isRequired,
    freeBetIsSelected: PropTypes.bool.isRequired,
    freeBetAmount: PropTypes.number,
}

export default ActionBar;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/ActionBar/ActionBar.jsx